/**
 * Theme preference synchronization
 * Non-UI logic for syncing theme mode across storage and app state.
 */

import { brand } from '@brand';
import { setThemeMode } from '@infra/theme';

/**
 * Listen to storage changes across tabs/windows
 * Sync theme mode when changed externally
 */
export function initThemeSyncListener(): () => void {
  if (!brand.supportsDarkMode) return () => {};

  const handleStorageChange = (event: StorageEvent) => {
    if (!event.key?.includes('ui_prefs')) {
      return;
    }

    try {
      const parsed = event.newValue ? JSON.parse(event.newValue) : null;
      if (parsed?.mode && (parsed.mode === 'light' || parsed.mode === 'dark')) {
        setThemeMode(parsed.mode);
      }
    } catch {
      // Ignore parse errors
    }
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }

  return () => {};
}
